<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    level: number;
    bonus: number;
    brand: string;
    color: string;
    showMeta?: boolean;
    title?: string;
    size?: "sm" | "md";
  }>(),
  {
    showMeta: true,
  }
);
</script>

<template>
  <div class="flex w-full flex-col gap-2 cursor-default overflow-hidden">
    <div class="text-ellipsis overflow-hidden text-nowrap text-xs w-full">{{ title }}</div>
    <div class="w-full flex items-stretch justify-between text-black">
      <GearLevelChip :level="level" :size="size" />
      <Tooltip :text="t('card.equipment.bonus')">
        <div
          class="bg-neutral-950 rounded-md pr-1.5 pl-1 text-neutral-300 capitalize cursor-pointer text-xs h-full items-center flex"
        >
          <span class="">+{{ bonus }}</span
          >%
        </div>
      </Tooltip>
    </div>
    <div v-if="showMeta" class="flex flex-row gap-1 text-xs flex-wrap">
      <MetaChip v-if="brand" type="secondary" :text="brand" :tooltip="brand" />
      <MetaChip v-if="color" type="secondary" :text="color" :tooltip="color" />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
